/**
 * Single source of truth for locale list at build time.
 *
 * Mirrors `src/i18n/locales.ts` `SUPPORTED_LOCALES` (87 locales — aligned
 * with iOS xcstrings + Android values-* canonical set). Cannot import
 * TS from plain-Node script without a TS loader, so duplicated here.
 * A vitest unit test pins divergence (`src/i18n/locales.test.ts`).
 */
export const LOCALES = [
  'en',
  'am',
  'ar',
  'as',
  'az',
  'be',
  'bg',
  'bn',
  'ca',
  'cs',
  'da',
  'de',
  'el',
  'en-AU',
  'en-CA',
  'en-GB',
  'en-IN',
  'en-US',
  'es',
  'es-419',
  'es-ES',
  'es-MX',
  'et',
  'fa',
  'fi',
  'fil',
  'fr',
  'fr-CA',
  'fr-FR',
  'gu',
  'ha',
  'he',
  'hi',
  'hr',
  'hu',
  'id',
  'ig',
  'it',
  'ja',
  'jv',
  'kk',
  'km',
  'kn',
  'ko',
  'ky',
  'lt',
  'lv',
  'mg',
  'ml',
  'mr',
  'ms',
  'my',
  'nb',
  'ne',
  'nl',
  'ny',
  'om',
  'or',
  'pa',
  'pl',
  'ps',
  'pt',
  'pt-BR',
  'ro',
  'ru',
  'sd',
  'sh',
  'sk',
  'sl',
  'so',
  'su',
  'sv',
  'sw',
  'ta',
  'te',
  'th',
  'tr',
  'uk',
  'ur',
  'uz',
  'vi',
  'yo',
  'yue',
  'zh',
  'zh-HK',
  'zh-Hans',
  'zh-Hant',
]

export const DEFAULT_LOCALE = 'en'
export const RTL_LOCALES = new Set(['ar', 'he', 'fa', 'ur', 'ps'])
export const BASE_URL = 'https://london-tube.com'
